import GraphicEqIcon from '@mui/icons-material/GraphicEq';
import { useTranslation } from 'react-i18next';
import useTimeAgo from '../../../../../../../../../../../Hooks/useTimeAgo';
import useIsAppEnabled from '../../../../../../../../../../LiveContext/ApplicationSyncContext/useIsAppEnabled';
import { LatestDetection } from '../../../../../../../../../../LiveContext/NewSessionContext/Contexts/SessionDetectionContextProvider/useSessionDetectionContext';
import StyledTypography from './styles';

function DetectionLine(props: { detection: LatestDetection & { cardTitle?: string, commandTitle?: string, isIntention?: boolean }, isHighlighted: boolean, density?: 'panel' | 'page' }) {
  const { detection, isHighlighted, density = 'panel' } = props;
  const timeAgo = useTimeAgo(detection.date);
  const { t } = useTranslation();
  const isAppEnabled = useIsAppEnabled();

  return (
    <StyledTypography key={detection.id} density={density} isHighlighted={isHighlighted} isFromClient={detection.isFromClient} isIntention={detection.isIntention} title={detection.isIntention ? t('home-page.commands.intention.tooltip') : undefined}>
      {isAppEnabled && <GraphicEqIcon titleAccess={detection.isFromClient ? t('detections.fromClient.tooltip') : t('detections.fromAgent.tooltip')} />}
      <strong>{detection.commandTitle ?? '<command>'}</strong>
      {t('detections.detected', { timeAgo })}
    </StyledTypography>
  );
}

export default DetectionLine;
